// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"64a39bd8","774":"ecb4e5c4"}[chunkId] + ".chunk.js";
};